import React from 'react';
import { cn } from '../../lib/utils';

interface CardProps {
    children: React.ReactNode;
    className?: string;
    variant?: 'default' | 'glass' | 'gradient';
    padding?: 'none' | 'sm' | 'md' | 'lg';
}

export const Card: React.FC<CardProps> = ({
    children,
    className,
    variant = 'default',
    padding = 'md'
}) => {
    const variants = {
        default: 'bg-white border border-surface-200 shadow-glass-sm',
        glass: 'bg-white/80 backdrop-blur-glass border border-white/50 shadow-glass',
        gradient: 'bg-gradient-to-br from-white to-surface-50 border border-surface-200 shadow-glass',
    };

    const paddings = {
        none: '',
        sm: 'p-3',
        md: 'p-4',
        lg: 'p-6',
    };

    return (
        <div className={cn(
            'rounded-xl transition-all duration-300',
            variants[variant],
            paddings[padding],
            className
        )}>
            {children}
        </div>
    );
};

interface CardHeaderProps {
    children: React.ReactNode;
    className?: string;
    icon?: React.ReactNode;
}

export const CardHeader: React.FC<CardHeaderProps> = ({ children, className, icon }) => {
    return (
        <div className={cn('flex items-center gap-2 mb-4', className)}>
            {icon && (
                <span className="flex items-center justify-center w-8 h-8 rounded-lg bg-primary-100 text-primary-600">
                    {icon}
                </span>
            )}
            <h3 className="font-semibold text-surface-800">{children}</h3>
        </div>
    );
};

export const CardContent: React.FC<{ children: React.ReactNode; className?: string }> = ({ children, className }) => {
    return <div className={cn('space-y-4', className)}>{children}</div>;
};
